module.exports = __webpack_public_path__ + "img/物流.55b0aca1.gif";